import React, {useMemo, useState} from 'react';
import {Checkbox, Dropdown, Table, Tag} from "antd";
import UserImageCircle from "../../../components/UserImageCircle";
import {useTeamCandidateScope} from "./TeamCandidateScopeProvider";
import TeamMemberContactForm from "./TeamMemberContactForm";
import Opportunity from "../../../models/Opportunity";
import TeamPercentMarkupForm from "./TeamPercentMarkupForm";
import SpinLoader from "../../../components/SpinLoader";

const TeamMemberOppSummary = ({data = [], forAgency, canEdit, ...props}) => {


    let totalHours = 0;
    let totalProposedHours = 0;
    let totalEstCost = 0;
    let totalProposedEstCost = 0;
    let totalPlatformCost = 0;
    let totalProposedPlatformCost = 0;

    data.forEach((opp) => {
        if (opp.status !== Opportunity.Statuses.Lost) {
            totalHours += TB.sumBy(opp.disciplines, discipline => {
                return discipline.total_hours
            })
            totalProposedHours += TB.sumBy(opp.disciplines, discipline => {
                return discipline.proposed_total_periods || discipline.total_hours
            })
            totalEstCost += TB.sumBy(opp.disciplines, discipline => {
                return discipline.payout_amount
            })

            totalProposedEstCost += TB.sumBy(opp.disciplines, discipline => {
                return discipline.proposed_payout_amount || discipline.payout_amount
            })

            totalPlatformCost += TB.sumBy(opp.disciplines, discipline => {
                return discipline.platform_cost
            })
            totalProposedPlatformCost += TB.sumBy(opp.disciplines, discipline => {
                return discipline.proposed_platform_cost || discipline.platform_cost
            })
        }
    });

    return (
        <Table.Summary.Row className="bg-gray-300">
            {/*<Table.Summary.Cell index={0} className="bg-gray-50">*/}

            {/*</Table.Summary.Cell>*/}
            {/*NAME*/}
            <Table.Summary.Cell index={0} className="bg-gray-50">
                <p className="text-sm font-semibold text-right">
                    Totals
                </p>
            </Table.Summary.Cell>
            {/*ROLES*/}
            <Table.Summary.Cell index={1} className="bg-gray-50">

            </Table.Summary.Cell>
            {/*TALENT HOURS*/}
            <Table.Summary.Cell index={2} className="bg-gray-50">
                <div className="h-4 flex flex-row items-center justify-start gap-1.5">

                    {!forAgency && totalProposedHours !== totalHours && (
                        <React.Fragment>
                            <p className="whitespace-nowrap font-semibold">
                                <i className="fas fa-exclamation-triangle text-warning"/>
                            </p>
                            <p className="line-through text-black whitespace-nowrap font-semibold">
                                <span className="text-danger">
                                    {totalHours} Hrs
                                </span>
                            </p>
                        </React.Fragment>
                    )}
                    <p className="text-sm font-semibold whitespace-nowrap">
                        {totalProposedHours} Hrs
                    </p>
                </div>
            </Table.Summary.Cell>
            {/*TALENT RATE*/}
            <Table.Summary.Cell index={3} className="bg-gray-50">

            </Table.Summary.Cell>

            {/*TALENT COST*/}
            <Table.Summary.Cell index={4} className="bg-gray-50">
                <div className="h-4 flex flex-row items-center justify-start gap-1.5">

                    {!forAgency && totalProposedEstCost !== totalEstCost && (
                        <React.Fragment>
                            <p className="whitespace-nowrap font-semibold">
                                <i className="fas fa-exclamation-triangle text-warning"/>
                            </p>
                            <p className="line-through text-black whitespace-nowrap font-semibold">
                                <span className="text-danger">
                                    {TB.formatCurrency(totalEstCost, false)}
                                </span>
                            </p>
                        </React.Fragment>
                    )}
                    <p className="text-sm font-semibold whitespace-nowrap">
                        {TB.formatCurrency(totalProposedEstCost, false)}
                    </p>
                </div>
            </Table.Summary.Cell>

            {!forAgency && (
                <React.Fragment>
                    {/*CLIENT RATE*/}
                    <Table.Summary.Cell index={5} className="bg-gray-50">

                    </Table.Summary.Cell>

                    {/*CLIENT PAYOUT*/}
                    <Table.Summary.Cell index={6} className="bg-gray-50">
                        <div className="h-4 flex flex-row items-center justify-start gap-1.5">
                            {totalProposedPlatformCost !== totalPlatformCost && (
                                <React.Fragment>
                                    {/*<p className="whitespace-nowrap font-semibold">*/}
                                    {/*    <i className="fas fa-exclamation-triangle text-warning"/>*/}
                                    {/*</p>*/}
                                    <p className="line-through text-black whitespace-nowrap font-semibold">
                                        <span className="text-danger">
                                            {TB.formatCurrency(totalPlatformCost, false)}
                                        </span>
                                    </p>
                                </React.Fragment>
                            )}
                            <p className="text-sm font-semibold whitespace-nowrap">
                                {TB.formatCurrency(totalProposedPlatformCost, false)}
                            </p>
                        </div>
                    </Table.Summary.Cell>

                    {/*STATUS*/}
                    <Table.Summary.Cell index={7} className="bg-gray-50">

                    </Table.Summary.Cell>
                </React.Fragment>
            )}

            {/*ACTIONS*/}
            {canEdit && (
                <Table.Summary.Cell index={!forAgency ? 8 : 5} className="bg-gray-50">

                </Table.Summary.Cell>
            )}
        </Table.Summary.Row>
    );
}
const TeamMemberOppStatusTable = ({forAgency, hideHeader, canEdit = true, ...props}) => {

    const {
        team,
        isDisabled,
        isLoading,
        onEditTeamAssignment,
        sendRemindToAccept,
        removeDisciplineAssignmentForTeamMember
    } = useTeamCandidateScope();

    const [contactTalentOpp, setContactTalentOpp] = useState(false);

    const [filterOutLostOpps, setFilterOutLostOpps] = useState(true);

    const talentOpps = TB.filter(team?.job_candidate?.talent_opps || [], opp => {
        // if (forAgency) {
        //     return TB.filter(opp.disciplines, dis => dis.total_hours > 0)?.length > 0
        // }
        return (!forAgency && filterOutLostOpps) ? opp.status !== Opportunity.Statuses.Lost : true
    });

    const columnWidths = useMemo(() => {
        const talentOppDisciplines = TB.flatMap(TB.filter(talentOpps, {
            rejected_at: null,
            withdrew_at: null
        }), 'disciplines')
        const unmatchedHours = !forAgency && TB.find(talentOppDisciplines, ['matches_total_periods', false]);
        const unmatchedRate = !forAgency && TB.find(talentOppDisciplines, ['matches_hourly_rate', false]);
        const unmatchedPayout = !forAgency && TB.find(talentOppDisciplines, ['matches_payout', false]);

        let MemberWidth = 210;
        let RolesWidth = 210;

        if (!forAgency && unmatchedPayout) {
            MemberWidth -= 25
            RolesWidth -= 10
        } else if (forAgency) {
            MemberWidth += 20
            RolesWidth += 20
        }
        let clientColumns = !forAgency ? {
            Client_Rate: unmatchedRate ? 180 : 125,
            Client_Cost: unmatchedPayout ? 180 : 125,
            Status: canEdit ? 90 : 120,
        } : {}
        return {
            Member: MemberWidth,
            Roles: RolesWidth,
            // Talent_Group: 375,
            Talent_Hours: unmatchedHours ? 180 : 125,
            Talent_Rate: unmatchedRate ? 180 : 125,
            Talent_Payout: unmatchedPayout ? 180 : 125,
            // Client_Group: 220,
            ...clientColumns,
            Actions: canEdit ? 90 : 0,
        }

    }, [talentOpps, isDisabled]);


    if (isLoading || !team) {
        return null
    }
    return (
        <SpinLoader isLoading={isDisabled}>
            {!hideHeader && (
                <div className="flex flex-row items-center justify-between mb-6">
                    <div className="flex flex-row items-center gap-4">
                        {/*<p className="text-lg font-semibold underline">*/}
                        {/*    Team Assignment*/}
                        {/*</p>*/}
                        {!forAgency && (
                            <Checkbox checked={filterOutLostOpps} onChange={e => {
                                setFilterOutLostOpps(e.target.checked)
                            }}>
                                Hide members removed or replaced
                            </Checkbox>
                        )}
                    </div>

                    {!forAgency && <TeamPercentMarkupForm/>}
                </div>
            )}
            <Table
                scroll={{x: TB.sum(TB.values(columnWidths))}}
                rowClassName={(opp) => opp.status === Opportunity.Statuses.Lost ? "bg-gray-50 opp-lost" : ""}
                pagination={false} rowKey='id' className="team-member-opp-status-table"
                dataSource={TB.orderBy(talentOpps, opp => opp.status === Opportunity.Statuses.Lost ? 1 : 0, 'desc')}
                summary={(pageData) => <TeamMemberOppSummary data={pageData} forAgency={forAgency} canEdit={canEdit}/>}
            >

                {/*<Table.Column title="ID" dataIndex="id" key="id"*/}
                {/*              render={(id) => (*/}
                {/*                  <p key={id}*/}
                {/*                     className="text-xs font-semibold text-info">*/}
                {/*                      {id}*/}
                {/*                  </p>*/}
                {/*              )}/>*/}
                <Table.Column
                    title="Member"
                    dataIndex="user"
                    key="user"
                    fixed="left"
                    width={columnWidths.Member}
                    render={(user, opp) => (
                        <div key={opp.id + '-user-' + user.id}
                             className="flex flex-row items-center gap-1.5">
                            <UserImageCircle user={user} size={32}/>
                            <p className="font-semibold text-xs">
                                {user.fullName()}
                            </p>
                        </div>
                    )}/>
                <Table.Column
                    title="Roles"
                    dataIndex="disciplines"
                    key="disciplines"
                    width={columnWidths.Roles}
                    render={(disciplines, opp) => (
                        <div className="flex flex-col items-start gap-2">
                            {disciplines.map((discipline) => (
                                <div
                                    key={`${team.id}-roles-${discipline.id}`}
                                    className="h-4 flex flex-row items-center justify-start gap-1.5">
                                    <Tag color={opp.status === Opportunity.Statuses.Lost ? undefined : "purple"}
                                         key={opp.id + '-role-' + discipline.id}>
                                        {discipline.name}
                                    </Tag>
                                </div>
                            ))}
                        </div>
                    )}
                />
                <Table.ColumnGroup
                    title={!forAgency ? "Proposed Talent Payout" : "Proposed Project Cost"}
                    dataIndex="disciplines"
                    key="disciplines"
                >
                    <Table.Column
                        title="Hours"
                        dataIndex="disciplines"
                        key="disciplines"
                        width={columnWidths.Talent_Hours}
                        render={(disciplines, opp) => (
                            <div
                                className="flex flex-col items-start gap-2">
                                {TB.map(disciplines, discipline => {
                                    // const isPending = !(opp.rejected_at || opp.withdrew_at) && discipline.matches_hourly_rate && !opp.accepted_at;

                                    // console.log('discipline.matches_hourly_rate', )
                                    return (
                                        <div key={`${opp.id}-dis-hours-${discipline.id}`}
                                             className="h-4 flex flex-row items-center justify-start gap-1.5">
                                            {!forAgency && (
                                                <React.Fragment>
                                                    <p className="text-sm whitespace-nowrap">
                                                        <i className={TB.mapClass("fas", {
                                                            "fa-times-circle text-danger": opp.rejected_at || opp.withdrew_at,
                                                            "fa-clock text-gray-300": discipline.matches_total_periods && !opp.accepted_at && !opp.rejected_at && !opp.withdrew_at,
                                                            "fa-check-circle text-success": !(opp.rejected_at || opp.withdrew_at) && discipline.matches_total_periods && opp.accepted_at,
                                                            "fa-exclamation-triangle text-warning": !(opp.rejected_at || opp.withdrew_at) && !discipline.matches_total_periods
                                                        })}/>
                                                    </p>
                                                    {!discipline.matches_total_periods && (
                                                        <p className="text-sm line-through text-black whitespace-nowrap">
                                                            <span className="text-danger">
                                                                {discipline.total_hours} Hrs
                                                            </span>
                                                        </p>
                                                    )}

                                                </React.Fragment>
                                            )}

                                            <p className="text-sm font-medium whitespace-nowrap">
                                                {discipline.proposed_total_periods || discipline.total_hours} Hrs
                                            </p>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    />
                    <Table.Column
                        title="Talent Rate"
                        dataIndex="disciplines"
                        key="disciplines"
                        width={columnWidths.Talent_Rate}
                        render={(disciplines, opp) => (
                            <div className="flex flex-col items-start gap-2">

                                {TB.map(disciplines, discipline => {
                                    return (
                                        <div key={`${opp.id}-dis-rate-${discipline.id}`}
                                             className="h-4 flex flex-row items-center justify-start gap-1.5">
                                            {!forAgency && (
                                                <React.Fragment>
                                                    <p className="text-sm whitespace-nowrap">
                                                        <i className={TB.mapClass("fas", {
                                                            "fa-times-circle text-danger": opp.rejected_at || opp.withdrew_at,
                                                            "fa-clock text-gray-300": !(opp.rejected_at || opp.withdrew_at) && discipline.matches_hourly_rate && !opp.accepted_at,
                                                            "fa-check-circle text-success": !(opp.rejected_at || opp.withdrew_at) && discipline.matches_hourly_rate && opp.accepted_at,
                                                            "fa-exclamation-triangle text-warning": !(opp.rejected_at || opp.withdrew_at) && !discipline.matches_hourly_rate
                                                        })}/>
                                                    </p>
                                                    {!discipline.matches_hourly_rate && (
                                                        <p className="text-sm line-through text-black whitespace-nowrap">
                                                            <span className="text-danger">
                                                                {TB.formatCurrency(discipline.hourly_rate)}/hr
                                                            </span>
                                                        </p>
                                                    )}

                                                </React.Fragment>
                                            )}


                                            <p className="text-sm font-medium whitespace-nowrap">
                                                {TB.formatCurrency(discipline.proposed_hourly_rate || discipline.hourly_rate)}/hr
                                            </p>

                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    />
                    <Table.Column
                        title={!forAgency ? "Talent Payout" : "Labor Cost"}
                        dataIndex="disciplines"
                        key="disciplines"
                        width={columnWidths.Talent_Payout}
                        render={(disciplines, opp) => {
                            const hasProposedPayout = TB.find(disciplines, ['matches_payout', false]);
                            const estimatedPayout = TB.sumBy(disciplines, 'payout_amount')
                            const proposedPayout = TB.sumBy(disciplines, discipline => discipline.proposed_payout_amount || discipline.payout_amount)

                            return (
                                <div className="flex flex-col items-start gap-2">

                                    <div className="h-4 flex flex-row items-center justify-start gap-1.5">
                                        {!forAgency && (
                                            <React.Fragment>
                                                <p className="text-sm whitespace-nowrap">
                                                    <i className={TB.mapClass("fas", {
                                                        "fa-times-circle text-danger": opp.rejected_at || opp.withdrew_at,
                                                        "fa-clock text-gray-300": !(opp.rejected_at || opp.withdrew_at) && !hasProposedPayout && !opp.accepted_at,
                                                        "fa-check-circle text-success": !(opp.rejected_at || opp.withdrew_at) && !hasProposedPayout && opp.accepted_at,
                                                        "fa-exclamation-triangle text-warning": !(opp.rejected_at || opp.withdrew_at) && hasProposedPayout
                                                    })}/>
                                                </p>
                                                {hasProposedPayout && (
                                                    <p className="text-sm whitespace-nowrap line-through text-black">
                                                        <span className="text-danger">
                                                            {TB.formatCurrency(estimatedPayout, false)}
                                                        </span>
                                                    </p>
                                                )}

                                            </React.Fragment>
                                        )}


                                        <p className="text-sm whitespace-nowrap font-medium">
                                            {TB.formatCurrency(hasProposedPayout ? proposedPayout : estimatedPayout, false)}
                                        </p>
                                    </div>
                                </div>
                            )
                        }}
                    />
                </Table.ColumnGroup>
                {!forAgency && (
                    <React.Fragment>
                        <Table.ColumnGroup
                            title={<span className="text-info">Estimated Client Fee</span>}
                            dataIndex="disciplines"
                            key="disciplines"
                        >
                            <Table.Column
                                title={<span className="text-info">Bill Rate</span>}
                                dataIndex="disciplines"
                                key="disciplines"
                                width={columnWidths.Client_Rate}
                                render={(disciplines, opp) => (
                                    <div className="flex flex-col items-start gap-2">

                                        {TB.map(disciplines, discipline => {
                                            const rate = discipline.matches_hourly_rate ? parseFloat(discipline.hourly_rate) : parseFloat(discipline.proposed_hourly_rate);

                                            return (
                                                <div key={`${opp.id}-dis-rate-${discipline.id}`}
                                                     className="h-4 flex flex-row items-center justify-start gap-1.5">
                                                    {!forAgency && !discipline.matches_hourly_rate && (
                                                        <p className="text-sm line-through text-black whitespace-nowrap">
                                                            <span className="text-danger">
                                                                ${TB.formatNumber(parseFloat(discipline.hourly_rate) * (1 + team.job_candidate.percent_markup), 2)}/hr
                                                            </span>
                                                        </p>
                                                    )}


                                                    <p className="text-sm whitespace-nowrap">
                                                        ${TB.formatNumber(rate * (1 + team.job_candidate.percent_markup), 2)}/hr
                                                    </p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}
                            />
                            <Table.Column
                                title={<span className="text-info">Client Fee</span>}
                                dataIndex="disciplines"
                                key="disciplines"
                                width={columnWidths.Client_Cost}
                                render={(disciplines, opp) => {
                                    const hasProposedCost = TB.find(disciplines, ['matches_payout', false]);
                                    const estimatedCost = TB.sumBy(disciplines, 'platform_cost')
                                    const proposedCost = TB.sumBy(disciplines, discipline => discipline.proposed_platform_cost || discipline.platform_cost)

                                    return (
                                        <div className="flex flex-col items-start gap-2">
                                            <div className="h-4 flex flex-row items-center justify-start gap-1.5">
                                                {!forAgency && hasProposedCost && (
                                                    <p className="text-sm whitespace-nowrap line-through text-black">
                                                        <span className="text-danger">
                                                            {TB.formatCurrency(estimatedCost, false)}
                                                        </span>
                                                    </p>
                                                )}


                                                <p className="text-sm whitespace-nowrap">
                                                    {TB.formatCurrency(hasProposedCost ? proposedCost : estimatedCost, false)}
                                                </p>
                                            </div>
                                        </div>
                                    )
                                }}
                            />
                        </Table.ColumnGroup>
                        <Table.Column
                            title="Status"
                            dataIndex="accepted_at"
                            key="accepted_at"
                            align="center"
                            fixed={canEdit ? undefined : "right"}
                            width={columnWidths.Status}
                            render={(_, opp) => {
                                const hasProposedPayout = TB.find(opp.disciplines, ['matches_payout', false]);

                                if (opp.status === Opportunity.Statuses.Lost) {
                                    return (
                                        <p className="text-xs whitespace-nowrap">
                                            <span className="opacity-90 flex flex-col tect-center">
                                                <i>Lost</i>
                                            </span>
                                        </p>
                                    )
                                }
                                return (
                                    <p className="text-xs whitespace-nowrap text-center">
                                        {opp.withdrew_at ? (
                                            <span className="text-danger flex flex-col">
                                                <span>Withdrew:</span>
                                                <span>{TB.moment(opp.withdrew_at).format('ll')}</span>
                                            </span>
                                        ) : (opp.rejected_at ? (
                                            <span className="text-danger flex flex-col">
                                                <span>Rejected:</span>
                                                <span>{TB.moment(opp.rejected_at).format('ll')}</span>
                                            </span>
                                        ) : (opp.accepted_at ? (
                                            <span className="font-medium flex flex-col">
                                                {hasProposedPayout ?
                                                    <span className="text-warning">Proposed:</span> :
                                                    <span>Accepted:</span>
                                                }
                                                <span>{TB.moment(opp.accepted_at).format('ll')}</span>
                                            </span>
                                        ) : (
                                            <span className="opacity-90 flex flex-col">
                                                <i>Pending</i>
                                            </span>
                                        )))}
                                    </p>
                                )
                            }}
                        />
                    </React.Fragment>
                )}


                {canEdit && (
                    <Table.Column
                        title="Actions"
                        dataIndex="id"
                        width={columnWidths.Actions}
                        key="id"
                        fixed="right"
                        render={(_, opp) => {
                            const hasProposedPayout = TB.find(opp.disciplines, ['matches_payout', false]);

                            const disciplinesMenuItems = TB.map(TB.filter(team.disciplines, ['talent_opp.id', opp.id]), dis => {
                                return {
                                    key: dis.id,
                                    label: dis.name
                                }
                            })
                            const onEditDiscipline = (key) => {
                                let match = TB.find(team.disciplines, ['id', parseInt(key)]);
                                if (!match) return;

                                onEditTeamAssignment(match)
                            }
                            const onRemoveDiscipline = (key) => {
                                removeDisciplineAssignmentForTeamMember(parseInt(key))
                            }

                            return (
                                <div className="flex flex-col items-stretch gap-1 justify-center">
                                    {!forAgency && (
                                        <React.Fragment>
                                            {!opp.reminded_to_accept_at && (!opp.withdrew_at && !opp.rejected_at && !opp.accepted_at && !hasProposedPayout) && (
                                                <button
                                                    disabled={opp.accepted_at || isDisabled}
                                                    onClick={() => sendRemindToAccept(opp)}
                                                    className="btn btn-link btn-link-info whitespace-nowrap text-xs py-0.5 text-right">
                                                    Remind
                                                </button>
                                            )}
                                            {!opp.withdrew_at && !opp.rejected_at && hasProposedPayout && (
                                                <button disabled={isDisabled}
                                                        onClick={() => setContactTalentOpp(opp)}
                                                        className="btn btn-link btn-link-primary whitespace-nowrap text-xs py-0.5 text-right">
                                                    Contact
                                                </button>
                                            )}
                                        </React.Fragment>
                                    )}
                                    {disciplinesMenuItems?.length > 0 && (
                                        disciplinesMenuItems?.length > 1 ? (
                                            <React.Fragment>
                                                {(opp.withdrew_at || opp.rejected_at) && (
                                                    <Dropdown
                                                        disabled={isDisabled}
                                                        menu={{
                                                            items: disciplinesMenuItems,
                                                            onClick: ({key}) => onRemoveDiscipline(key)
                                                        }}
                                                        trigger={['click']}
                                                    >
                                                        <button disabled={isDisabled}
                                                                onClick={(e) => e.preventDefault()}
                                                                className="btn btn-link btn-link-danger whitespace-nowrap text-xs py-0.5 text-right">
                                                            Remove
                                                        </button>

                                                    </Dropdown>
                                                )}
                                                <Dropdown
                                                    disabled={isDisabled}
                                                    menu={{
                                                        items: disciplinesMenuItems,
                                                        onClick: ({key}) => onEditDiscipline(key)
                                                    }} trigger={['click']}>
                                                    <button disabled={isDisabled}
                                                            onClick={(e) => e.preventDefault()}
                                                            className="btn btn-link btn-link-danger whitespace-nowrap text-xs py-0.5 text-right">
                                                        Edit
                                                    </button>
                                                </Dropdown>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                {(opp.withdrew_at || opp.rejected_at) && (
                                                    <React.Fragment>
                                                        <button
                                                            onClick={() => onRemoveDiscipline(TB.first(disciplinesMenuItems).key)}
                                                            disabled={isDisabled}
                                                            className="btn btn-link btn-link-danger whitespace-nowrap text-xs py-0.5 text-right">
                                                            Remove
                                                        </button>
                                                    </React.Fragment>
                                                )}

                                                <button disabled={isDisabled}
                                                        onClick={(e) => onEditDiscipline(TB.first(disciplinesMenuItems).key)}
                                                        className="btn btn-link btn-link-danger whitespace-nowrap text-xs py-0.5 text-right">
                                                    Edit
                                                </button>
                                            </React.Fragment>
                                        )
                                    )}
                                </div>
                            )
                        }}
                    />
                )}
            </Table>


            {!forAgency && (
                <TeamMemberContactForm
                    talentOpp={contactTalentOpp}
                    onClose={() => setContactTalentOpp(null)}/>
            )}

        </SpinLoader>
    )
}

TeamMemberOppStatusTable.propTypes = {};

export default TeamMemberOppStatusTable;